module.exports = __webpack_public_path__ + "img/workContents02_pc.019294ce.png";